import moment from "moment-timezone"

const isBirthdateSameAsEventDate = (birthdate, eventStartDate) => {
  let reference_date = moment(reformatDate(eventStartDate), momentDateFormat)
  let the_birthdate = moment(reformatDate(birthdate), momentDateFormat)

  if (reference_date.month() === the_birthdate.month()) {
    if (the_birthdate.date() === reference_date.date()) {
      return true
    }
  }
  return false
}

const ageInMonthsAtTimeOfEvent = (birthdate, eventStartDate) => {
  let safeStartDate = eventStartDate ? eventStartDate : new Date().toISOString()
  let reference_date = moment(reformatDate(safeStartDate), momentDateFormat)
  let the_birthdate = moment(reformatDate(birthdate), momentDateFormat)
  let ageInMonths = 0

  ageInMonths = reference_date.diff(the_birthdate, "months")

  ageInMonths = Math.abs(ageInMonths) ? Math.abs(ageInMonths) : 0

  return ageInMonths
}

const meetsAttendeeTypeAgeRestriction = (
  attendeeType,
  birthdate,
  eventStartDate,
  preCalculatedAgeInMonths
) => {
  let minAge = attendeeType.minAgeInMonths
  let maxAge = attendeeType.maxAgeInMonths

  if (!birthdate) {
    return false
  }
  let attendeeAge = Number(preCalculatedAgeInMonths)
    ? Number(preCalculatedAgeInMonths)
    : ageInMonthsAtTimeOfEvent(birthdate, eventStartDate)

  minAge = Number(minAge) ? Number(minAge) : 0
  maxAge = Number(maxAge) ? Number(maxAge) : 9999

  if (isBirthdateSameAsEventDate(birthdate, eventStartDate)) {
    if (minAge === attendeeAge) {
      minAge -= 1
    }
    if (maxAge === attendeeAge - 1) {
      maxAge += 1
    }
  }

  return minAge <= attendeeAge && attendeeAge <= maxAge
}

const reformatDate = (date = "") => {
  const dateString = date instanceof Date ? date.toISOString() : date

  let match = dateString && dateString.match(/(\d{4})-(\d{2})-(\d{2})/)
  if (match) {
    return momentDateFormat.startsWith("D")
      ? `${match[3]}/${match[2]}/${match[1]}`
      : `${match[2]}/${match[3]}/${match[1]}`
  }
  return dateString
}

export { isBirthdateSameAsEventDate }
export { ageInMonthsAtTimeOfEvent }
export { meetsAttendeeTypeAgeRestriction }
export { reformatDate }
